// @flow

import type {AuthBloc} from "../../blocs/authBloc";
import {apiAxios} from '../../config/AxiosConfig'
import { AppToaster } from "../../components/Toaster/Toaster";
import { Intent } from "@blueprintjs/core";
import history from "../../history";

class BrandApi {

    authBloc : AuthBloc;

    constructor(authBloc: AuthBloc) {
        this.authBloc = authBloc;
    }

    async getBrand() : Promise<Object> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.get(`/tenants/${tenantId}/brands`, this.buildHeaders());

        return response.data;
    }

    async createBrand(brand: Object) : Promise<Object> {
        try {
            const tenantId = this.authBloc.getCurrentTenant();

            const response = await apiAxios.post(`/tenants/${tenantId}/brands`, brand, {...this.buildHeaders(), skipErrorToast: true});
            if (response.status === 200 || response.status === 201) {
                history.goBack();
                setTimeout(() => {
                    AppToaster.show({
                        message: "Brand Information Created",
                        intent: Intent.SUCCESS
                    });
                }, 300);
                return response.data;
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            AppToaster.show({
                message: error.response?.data?.message || 'Failed to create brand. Please try again.',
                intent: Intent.DANGER
            });
        }
    }

    async updateBrand(brand: Object) : Promise<Object> {
        try {
            const tenantId = this.authBloc.getCurrentTenant();

            const response = await apiAxios.put(`/tenants/${tenantId}/brands`, brand, {...this.buildHeaders(), skipErrorToast: true});
            if (response.status === 200 || response.status === 204) {
                history.goBack();
                setTimeout(() => {
                    AppToaster.show({
                        message: "Brand Information Updated",
                        intent: Intent.SUCCESS
                    });
                }, 300);
                return response.data;
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            AppToaster.show({
                message: error.response?.data?.message || 'Failed to update brand. Please try again.',
                intent: Intent.DANGER
            });
        }
    }

    async requestLogoUploadUrl(logo: Object) : Promise<string> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.post(`/tenants/${tenantId}/logo`, logo, this.buildHeaders());

        return response.data;
    }

    async uploadLogoPayload(url: string, logoInformation: Object) : Promise<void> {
        const file = logoInformation.payload;
        const type = file.split(";")[1].split(",")[0];
        const buffer = Buffer.from(
            file.replace(/^data:[a-zA-Z0\-\/]*\/\w+;base64,/, ""),
            "base64"
        );

        try {
            return await apiAxios.put(url, buffer, {
                headers: {
                    "Content-Type": logoInformation.fileType,
                    "Content-Encoding": type,
                },
            });
        } catch (error) { }
    }

    buildHeaders = ()=> {
        const accessToken = this.authBloc.getCurrentToken();
        const auth = "Bearer " + accessToken;
        return {headers:{Authorization:auth}};
    }
}

export default BrandApi;
